import type { GetOwnerMaskedInfoResponse } from "wagAPI";
import type { GetOwnerMaskedInfoParsedResponse } from "webApp";
export const getOwnerMaskedInfoResponseParser = ({
  masked_email: maskedEmail,
  masked_phone: maskedPhone
}: GetOwnerMaskedInfoResponse) => ({
  maskedEmail,
  maskedPhone
} as GetOwnerMaskedInfoParsedResponse);
export default getOwnerMaskedInfoResponseParser;